import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import styled from 'styled-components'

import { ROUTES } from '../../constants/routes'
import { getDisplayRequestId } from '../../utils/apiError'
import { Button } from '../ui'

export default function AppErrorFallback({ error }) {
  const requestId = getDisplayRequestId(error)

  return (
    <PageRoot role="alert" aria-labelledby="app-error-title">
      <Panel>
        <StatusIcon aria-hidden="true"><ErrorOutlineRoundedIcon /></StatusIcon>
        <ErrorCode>UNEXPECTED ERROR</ErrorCode>
        <h1 id="app-error-title">화면을 표시하는 중 문제가 발생했어요</h1>
        <Description>
          화면을 다시 불러와 주세요.<br />
          문제가 계속되면 처음 화면으로 이동해 다시 시작할 수 있어요.
        </Description>
        {requestId && (
          <RequestReference>
            요청 식별자: <code>{requestId}</code>
          </RequestReference>
        )}
        <Actions>
          <Button onClick={() => window.location.reload()}>
            <RefreshRoundedIcon aria-hidden="true" fontSize="small" />
            화면 다시 불러오기
          </Button>
          <Button $variant="secondary" onClick={() => window.location.assign(ROUTES.ROOT)}>
            <HomeRoundedIcon aria-hidden="true" fontSize="small" />
            처음으로 이동
          </Button>
        </Actions>
      </Panel>
    </PageRoot>
  )
}

const PageRoot = styled.main`
  display: grid;
  min-height: 100dvh;
  place-items: center;
  padding: 24px;
  background: ${({ theme }) => theme.colors.background};
`

const Panel = styled.section`
  width: min(100%, 680px);
  padding: clamp(36px, 7vw, 64px);
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.large};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadow.medium};

  h1 {
    margin: 14px 0 18px;
    color: ${({ theme }) => theme.colors.text};
    font-size: clamp(1.45rem, 3.4vw, 1.8rem);
    line-height: 1.35;
    word-break: keep-all;
  }
`

const StatusIcon = styled.div`
  display: grid;
  width: 54px;
  height: 54px;
  margin: 0 auto 18px;
  place-items: center;
  color: ${({ theme }) => theme.colors.danger};
  border-radius: 18px;
  background: ${({ theme }) => theme.colors.progressSoft};

  svg {
    font-size: 28px;
  }
`

const ErrorCode = styled.span`
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.14em;
`

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.7;
`

const RequestReference = styled.p`
  margin: 18px 0 0;
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.82rem;
  line-height: 1.6;

  code {
    color: ${({ theme }) => theme.colors.text};
    font-family: inherit;
    font-weight: 700;
    overflow-wrap: anywhere;
    user-select: all;
  }
`

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 30px;
`
